import { isNumber } from 'lodash';
import YasTable from 'mpm-components/commons/YasTable';
import { default as React } from 'react';
import NumberFormat from 'react-number-format';
import { Button, Dropdown, Form, Icon, Input } from 'semantic-ui-react';
export const LignesExistants = ({ dataSet, onAddRow, editMode, pays }) => {
  const [dataList, setDataList] = React.useState([...dataSet]);

  React.useEffect(() => {
    setDataList([...dataSet]);
  }, [dataSet]);

  const formatTaille = (value) => {
    return String(value)
      .toLocaleUpperCase()
      .replace(/[^\w\s]/gi, '')
      .split(' ')
      .join('');
  };

  const handleChange = (e, { name, value }, index) => {
    let cleanedValue = null;
    if (name === 'tailleCommerciale') {
      cleanedValue = formatTaille(value);
    } else if (name !== 'tailleCommerciale') {
      cleanedValue = isNumber(value) ? value : Number(value.replace(/[^0-9.]/g, ''));
    }

    const tempList = [...dataList];
    tempList[index] = { ...dataList[index], [name]: cleanedValue };
    setDataList(tempList);
  };

  return (
    <YasTable
      title="Especes"
      options={{ stackable: false, striped: true, attached: false, celled: true }}
      header={[
        {
          selector: 'refEspece.libelle',
          textAlign: 'center',
          label: 'Espece',
        },
        {
          selector: 'id_refPaysExp',
          textAlign: 'center',
          label: "Pays d'expédition",
          component: (row, index) => <Dropdown selection name="id_refPaysExp" clearable value={row.id_refPaysExp} options={pays.data} onChange={(evt, p) => handleChange(evt, p, index)} />,
        },
        {
          selector: 'poidsADebarqueEstime',
          textAlign: 'center',
          label: 'Poids',
          component: (row, index) => <NumberFormat min={0} displayType={'text'} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={('.', ',')} value={row.poidsADebarqueEstime} />,
        },
        {
          selector: 'quantite',
          textAlign: 'center',
          label: 'Quantité',
          component: (row, index) => <NumberFormat decimalScale={2} thousandSeparator=" " allowedDecimalSeparators={'.'} customInput={Form.Input} name="quantite" min={0} max={row.poidsADebarqueEstime} disabled={!editMode} value={row.quantite} error={row.quantite > row.poidsADebarqueEstime} onChange={(evt, p) => handleChange(evt, { name: 'quantite', value: evt.target.value }, index)} />,
        },
        {
          selector: 'valeur',
          textAlign: 'center',
          label: 'Valeur en $',
          component: (row, index) => <NumberFormat name="valeur" min={0} customInput={Form.Input} displayType={editMode ? 'input' : 'text'} thousandSeparator="" decimalScale={3} allowedDecimalSeparators={('.', ',')} disabled={!editMode} value={row.valeur} onChange={(evt, p) => handleChange(evt, { name: 'valeur', value: evt.target.value }, index)} />,
        },
        {
          selector: 'nbCaisses',
          textAlign: 'center',
          label: 'NB Caisses',
          component: (row, index) => <Input name="nbCaisses" min={0} disabled={!editMode} value={row.nbCaisses} onChange={(evt, p) => handleChange(evt, p, index)} />,
        },
        {
          selector: 'tailleCommerciale',
          textAlign: 'center',
          label: 'Taille Commerciale',
          component: (row, index) => <Input name="tailleCommerciale" value={row.tailleCommerciale} type="text" onChange={(evt, p) => handleChange(evt, p, index)} />,
        },
        {
          selector: 'actions',
          textAlign: 'center',
          label: 'Actions',
          component: (row, index) => (
            <Button icon primary onClick={() => onAddRow(row)} size="tiny" floated="right">
              <Icon name="plus" />
            </Button>
          ),
        },
      ]}
      data={dataList}
      isEmpty={dataList?.length === 0}
    ></YasTable>
  );
};
const LignesEspeces = ({ dataSet, onDeleteRow, editMode, pays }) => {
  return (
    <YasTable
      title="Lignes"
      options={{ stackable: false, striped: true, attached: false, celled: true }}
      header={[
        {
          selector: 'refEspece.libelle',
          textAlign: 'center',
          label: 'Espece',
        },
        {
          selector: 'id_refPaysExp',
          textAlign: 'center',
          label: "Pays d'expédition",
          component: (row) => <Dropdown name="id_refPaysExp" defaultValue={row.id_refPaysExp} options={pays.data} disabled />,
        },

        {
          selector: 'quantite',
          textAlign: 'center',
          label: 'Quantité',
        },
        {
          selector: 'valeur',
          textAlign: 'center',
          label: 'Valeur',
        },
        {
          selector: 'nbCaisses',
          textAlign: 'center',
          label: 'NB Caisses',
        },

        {
          selector: 'tailleCommerciale',
          textAlign: 'center',
          label: 'Taille Commerciale',
        },
        {
          selector: 'action',
          textAlign: 'center',
          label: 'Actions',
          component: (row, index) => (
            <Button icon basic onClick={() => onDeleteRow(row, index)} size="tiny" floated="right" color="red" disabled={!editMode}>
              <Icon name="trash" />
            </Button>
          ),
        },
      ]}
      data={dataSet}
      isEmpty={dataSet?.length === 0}
    ></YasTable>
  );
};

export default LignesEspeces;
